<script>
import { MapGender } from "@/common/util";
import xorBy from "lodash/xorBy";
import cloneDeep from "lodash/cloneDeep";

export default {
  data() {
    const userId = this.$route.params.accountId;
    return {
      userId,
      tableData: [],
      userData: {
        staffId: "--",
        name: "--",
        gender: "--",
        phone: "--"
      },
      ProvinceList: [],
      addingNewRange: false,
      deleteRange: false,
      formInputArray: [
        // {
        //   label: "工号",
        //   keyName: "staffId",
        //   type: "text",
        //   isDisable: true
        // },
        {
          label: "姓名",
          keyName: "name",
          type: "text",
          isDisable: true
        }
      ],
      tableButtonArray: [
        {
          text: "撤销管理",
          key: "cancel"
        }
      ],
      ProvinceList: [],
      defaultValue: {}
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const userId = this.$route.params.accountId;
      const userData = await this.$http.getGroupOptometristById(userId);
      const userManagementRange = await this.$http.getGroupOptometristById(
        userId,
        true
      );
      if (userData) {
        this.userData.staffId = userData.content.staffId;
        this.userData.name = userData.content.name;
        this.userData.phone = userData.content.phone;
        this.userData.gender = MapGender(userData.content.gender);
      }
      if (userManagementRange) {
        this.tableData = userManagementRange;
      }
      const ProvinceList = await this.$http.getProvinceList();
      this.ProvinceList = ProvinceList;
      if (ProvinceList) {
        let tempChildren = [];
        const xorList = xorBy(ProvinceList, this.tableData, "name");
        xorList.forEach(o =>
          tempChildren.push({
            label: o.name,
            keyName: o.id
          })
        );
        let tempFormInputArray = this.formInputArray.filter(
          o => o.keyName !== "range"
        );
        tempFormInputArray.push({
          label: "管理范围",
          keyName: "range",
          type: "select",
          children: tempChildren
        });
        this.formInputArray = tempFormInputArray;
      }
    },
    async loadProvince() {
      const userId = this.$route.params.accountId;

      const userManagementRange = await this.$http.getGroupOptometristById(
        userId,
        true
      );
      if (userManagementRange) {
        this.tableData = userManagementRange;
      }
      const ProvinceList = cloneDeep(this.ProvinceList);

      if (ProvinceList) {
        let tempChildren = [];
        const xorList = xorBy(ProvinceList, this.tableData, "name");
        xorList.forEach(o =>
          tempChildren.push({
            label: o.name,
            keyName: o.id
          })
        );
        let tempFormInputArray = this.formInputArray.filter(
          o => o.keyName !== "range"
        );

        tempFormInputArray.push({
          label: "管理范围",
          keyName: "range",
          type: "select",
          children: tempChildren
        });
        this.formInputArray = tempFormInputArray;
      }
    },
    async removeProvinceByID() {
      const row = this.defaultValue;
      const userId = this.$route.params.accountId;

      const postData = {
        userId,
        districtId: row.id
      };

      let result = await this.$http.deleteOptometristDistrict(postData);
      if (result === "success") {
        this.loadProvince();
      }
    },
    async onAddingNewRange(data) {
      if (data) {
        const userId = this.$route.params.accountId;
        const postData = {
          userId,
          districtId: data.range
        };
        let result = await this.$http.addOptometristDistrict(postData);
        this.addingNewRange = false;
        if (result === "success") {
          this.loadProvince();
        }
      }
    },
    onOperationClick(row) {
      this.defaultValue = row;
      this.deleteRange = true;
    },
    onClickAdd() {}
  }
};
</script>
<template>
  <div class="visionManagementDetailIndex">
    <el-card class="box-card cardStyle" shadow="never">
      <div slot="header" class="clearfix">
        <span class="cardTitleText">基本信息</span>
      </div>
      <div class="text item">
        <el-row :gutter="24">
          <!-- <el-col :span="6">
            <div class="grid-content bg-purple">工号: {{userData.staffId}}</div>
          </el-col> -->
          <el-col :span="6">
            <div class="grid-content bg-purple">视觉训练师姓名: {{userData.name}}</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">性别: {{userData.gender}}</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">手机号: {{userData.phone}}</div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <div class="line"></div>
    <DialogForm
      v-if="deleteRange"
      formTitle="确认删除管理范围？"
      :defaultValue="defaultValue"
      @close="deleteRange = false"
      @submitForm="removeProvinceByID"
      confirmButton="确认"
    />
    <DialogForm
      v-if="addingNewRange"
      formTitle="添加管理范围"
      :formInputArray="formInputArray"
      :defaultValue="userData"
      @close="addingNewRange = false"
      @submitForm="onAddingNewRange"
    />
    <elementButton class="addNewRangeButton" @click="addingNewRange = true">添加管理范围</elementButton>
    <el-table
      :data="tableData"
      class="accountTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="name" align="left" label="省份"></el-table-column>
      <el-table-column prop="operation" align="left" label="操作" width="180">
        <template slot-scope="scope">
          <textButtonGroup
            :buttonArray="tableButtonArray"
            :rowData="scope.row"
            @onOperationClick="onOperationClick"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.visionManagementDetailIndex {
  .cardStyle {
    margin: 0 2%;
    border: 0px;
  }
  .cardTitleText {
    font-size: 16px;
    font-weight: bold;
  }
  .addNewRangeButton {
    width: 120px;
    height: 38px;
    // margin-top: 13px;
    border-radius: 3px;
    margin: 10px 3%;
  }

  .accountTable {
    margin: 20px 3%;
    border: 1px;
    width: 94%;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    th > .cell {
      font-weight: bold;
    }
  }

  .el-row {
    display: flex;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .el-col {
    align-self: center;
    border-radius: 4px;
  }

  .grid-content {
    padding: 15px 0px;
    border-radius: 4px;
  }

  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  .editButton {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/visionManagement/visionDetail.vue